export default "__VITE_ASSET__CDilTXsS__"